$(document).ready(function(){
    checkFatturazione();
});

  function checkFatturazione(){
    var messages = JSON.parse($('#messages').text());

    $('#master-dropdown').on('change', function(){
      if($(this).val() == 'Privato'){
        $('#dependent-azienda').addClass('hidden');
        $('#dependent-azienda2').addClass('hidden');
        $('#dependent-azienda3').addClass('hidden');
        $('#dependent-azienda4').addClass('hidden');
        $('#dependent-privato').removeClass('hidden');
      }
      else if($(this).val() == 'Azienda'){
        $('#dependent-azienda').removeClass('hidden');
        $('#dependent-azienda2').removeClass('hidden');
        $('#dependent-azienda3').removeClass('hidden');
        $('#dependent-azienda4').removeClass('hidden');
        $('#dependent-privato').addClass('hidden');
      }
      else{
        $('#dependent-azienda').addClass('hidden');
        $('#dependent-azienda2').addClass('hidden');
        $('#dependent-azienda3').addClass('hidden');
        $('#dependent-azienda4').addClass('hidden');
        $('#dependent-privato').addClass('hidden');
      }
    });

    $('#invoice-modal button').on('click', function(){
      var type = $('#master-dropdown').val();
      var codicefiscale = $('#codice-fiscale').val();
      var ragionesociale = $('#azienda-ragione-sociale').val();
      var piva = $('#partita-iva').val();
      var sdi = $('#codice-sdi').val();
      var pec = $('#pec').val();
      
      if(type.length > 0){
        $('#master-dropdown').removeClass('error');
        var valid = true;
        var text = '';

        if(type == 'Privato'){
          if(codicefiscale.length != 16){
            $('#codice-fiscale').addClass('error');
            valid = false
          }
          else{
            $('#codice-fiscale').removeClass('error');
          }
          text = messages.result_private_html.replace('{{codicefiscale}}', codicefiscale);
        }
        else{
          if(ragionesociale.length <= 0){
            $('#azienda-ragione-sociale').addClass('error');
            valid = false
          }
          else{
            $('#azienda-ragione-sociale').removeClass('error');
          }
          if(piva.length <= 0){
            $('#partita-iva').addClass('error');
            valid = false
          }
          else{
            $('#partita-iva').removeClass('error');
          }
          if(sdi.length <= 0){
            $('#codice-sdi').addClass('error');
            valid = false
          }
          else{
            $('#codice-sdi').removeClass('error');
          }
          text = messages.result_html
                .replace('{{ragionesociale}}', ragionesociale)
                .replace('{{piva}}', piva)
                .replace('{{sdi}}', sdi);
          if($('#pec').val().length > 0){
            text = messages.result_pec_html
                .replace('{{ragionesociale}}', ragionesociale)
                .replace('{{piva}}', piva)
                .replace('{{sdi}}', sdi)
                .replace('{{pec}}', pec);
          }
        }

        if(valid){
          $('#cartattr-invoice').val('Si');
          $('#cartattr-tipologia').val(type);
          if(type == 'Privato'){
            $('#cartattr-codicefiscale').val(codicefiscale);
            $('#cartattr-ragionesociale').val('');
            $('#cartattr-partitaiva').val('');
            $('#cartattr-codicesdi').val('');
            $('#cartattr-pec').val('');
          }
          else{
            $('#cartattr-codicefiscale').val('');
            $('#cartattr-ragionesociale').val(ragionesociale);
            $('#cartattr-partitaiva').val(piva);
            $('#cartattr-codicesdi').val(sdi);
            $('#cartattr-pec').val(pec);
          }
          $('#cart-invoicedata').html('<div class="inner"><p class="Text--subdued">'+text+'</p><a href="#" id="remove-invoice">'+messages.delete+'</a></div>');
          $('#remove-invoice').on('click', function(){
            $('#cart-invoicedata').html('');
            $('#cartattr-codicefiscale').val('');
            $('#cartattr-ragionesociale').val('');
            $('#cartattr-partitaiva').val('');
            $('#cartattr-codicesdi').val('');
            $('#cartattr-pec').val('');
            $('#cartattr-invoice').val('No');
            $('#cartattr-tipologia').val('');
          });
          vgg();
        }
      }
      else{
        $('#master-dropdown').addClass('error');
      }
    });
  }

  function vgg(){
    $('#invoice-modal').toggleClass('invoice-open');
  }

  //PNGMTN94E64E690S